<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div class="pay-price">
      <div class="pay-hint">支付金额</div>
      <div class="price-num"><span>￥</span>{{payInfo.payment_price}}</div>
    </div>
    <div class="hint-box">
      <!--    <div class="explain-title">商品说明  </div>-->
      <div class="goods-box" style="display: none;">
        <div class="goods-item" v-for="(item,index) in payInfo.order_goods" :key="index">
          <div class="goods-title">{{item.name}}</div>
          <div class="num">×{{item.number}}</div>
        </div>
      </div>
      <div class="bill-box justify-align" style="border-top: none;">
        <span>账单分类</span><span class="bill-name">商品</span>
      </div>
      <div class="bill-box justify-align">
        <span>账单编号</span><span class="bill-name">{{payInfo.payment_no}}</span>
      </div>
    </div>
    <div class="select-box">
      <van-radio-group v-model="radio">
        <div class="pay-item justify-align">
          <div class="pay-content left-justifying">
            <img :src="require('../../assets/'+appTheme+'/pay_wx.png')" alt="" />
            <div class="pay-txt">
              微信支付
              <span>建议微信用户用微信支付</span>
            </div>
          </div>
          <van-radio name="1" checked-color="#55BB3A"></van-radio>
        </div>
        <div class="pay-item justify-align">
          <div class="pay-content left-justifying">
            <img :src="require('../../assets/'+appTheme+'/pay_yl.png')" alt="" />
            <div class="pay-txt">
              银联支付
              <span>建议微信用户用微信支付</span>
            </div>
          </div>
          <van-radio name="2" checked-color="#55BB3A"></van-radio>
        </div>
        <!--      <div class="pay-item justify-align" style="border-bottom: none;">-->
        <!--        <div class="pay-content left-justifying">-->
        <!--          <img src="../../assets/pay_ye.png" alt="" />-->
        <!--          <div class="pay-txt">-->
        <!--            余额支付-->
        <!--            <span>建议微信用户用微信支付</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <van-radio name="3" checked-color="#55BB3A"></van-radio>-->
        <!--      </div>-->
      </van-radio-group>
    </div>
    <div class="btn-box justify-align">
      <!--    <div class="btn cancel-btn">取消支付</div>-->
      <van-button :disabled="isDisable" class="btn affirm-btn" @click="onSubmit">确认支付</van-button>
    </div>
  </div>
</template>


<script>
import { orderPayMoney } from '@/api/goods'
import axios from 'axios'
import qs from 'qs'
import {Toast} from "vant";
import storage from "@/utils/storage";
export default {
  name: "submitOrder",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      radio:'1',
      goodsId: '',
      payInfo: '',
      goodsInfo: '', // 商品详情
      submitNumber:'', // 提交数量
      payTypeId: '', // 一元购项目id
      payType: '', // 1微信支付、2银联支付 mpPay   3余额支付balance
      cartCome:0, // 商品详情页下单0 购物车下单是 1
      isDisable:false,
      loading:false,
      instance: ''
  }
  },
  created() {
    var data = this.$route.query.pay
    if (this.$route.query.pay != undefined) { // 正常进来

      // this.cartCome = this.$route.query.cartCome // // 商品详情页下单0 购物车下单是 1
      this.payInfo = JSON.parse(data)
      // console.log(this.cartCome)
      this.goodsId = this.$route.query.id
      if (this.$route.query.goodInfo!= undefined){
        var goodsInfo = this.$route.query.goodInfo
        // console.log(goodsInfo)
        this.goodsInfo = JSON.parse(goodsInfo)
      }
      this.submitNumber = this.$route.query.submitNumber

      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload",()=>{
        var goodsInfo = JSON.stringify(this.goodsInfo)
        this.$store.commit("setGoodsInfo", goodsInfo);
        this.$store.commit("setSubmitNumber",this.submitNumber)
        this.$store.commit("setCartCome",this.cartCome)
        var payInfo = JSON.stringify(this.payInfo)
        this.$store.commit("setPayInfo", payInfo);
        if (this.payTypeId !=''){ // 一元购
          this.$store.commit("setPayTypeId",this.payTypeId)
        }
      })
    } else { // 刷新进来
      console.log('刷新')
      var payInfo = JSON.parse(this.$store.state.payInfo)
      this.payInfo = payInfo
      this.goodsInfo = JSON.parse(this.$store.state.goodsInfo)
      this.submitNumber = JSON.parse(this.$store.state.submitNumber)
      // this.cartCome = this.$store.state.cartCome
      // 后退进来赋值end
      var oneId = this.$store.state.payTypeId
      if (oneId !=''){
        this.payTypeId = this.$store.state.payTypeId
      }
    }
// 创建实例时设置配置的默认值
//     this.instance = axios.create({
//       baseURL: 'https://dev-api.itos.cn/api',
//       headers: {
//         'content-type': 'application/x-www-form-urlencoded',
//         'Authorization': 'Bearer 738|AWhBaCLatlYDBuUgwjrGowdi8nw0Te6VMlbvrVdi'
//       }
//     });
    // 在实例已创建后修改默认值

  },
  methods: {
    onClickLeft() { // 后退赋值，因为vue 后退会重新加载
      // var goodsInfo = JSON.stringify(this.goodsInfo)
      // this.$store.commit("setGoodsInfo", goodsInfo);
      // this.$store.commit("setSubmitNumber",this.submitNumber)
      // if (this.payTypeId !=''){
      //   this.$store.commit("setPayTypeId",this.payTypeId)
      // }
      this.$router.go(-2);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    submitPayBtn(){
      console.log('提交订单')
      var payType = ''
      if(this.radio== '1'||this.radio== '2'){ // mpPay微信公众号支付
        payType = 'mpPay'
      } else { // balance余额支付
        payType = 'balance'
      }
      var data1 = {
        method:payType
      }
      var type= 'goods'
      var data =  qs.stringify(data1)
      this.$toast.loading({
        mask: false,
        duration: 0, // 一直存在
        forbidClick: true, // 禁止点击
        message: '加载中...'
      })
      var url = `/payment/${this.payInfo.id}/${type}`
      this.instance.post(url,data)
        .then(response => {
          this.$toast.clear()
          var res = response.data
          console.log(res)
          if(res.code == 200)
          {
            this.$toast(res.message)
          }else {
            this.$toast(res.message)
          }
        }).catch(error => {
        this.$toast.clear()
        console.log('响应错误')
        console.log(error)
        this.$toast(error.message);
      })
        .finally(() => this.loading = false)
    },
    onSubmit(){
      if (this.radio == ''){
        this.$toast('请选择支付方式')
        return false
      }
      var that = this
      var payType = ''
      if(this.radio== '1'||this.radio== '2'){ // mpPay微信公众号支付
        payType = 'mpPay'
      } else { // balance余额支付
        payType = 'balance'
      }
      var data = {
        method:payType
      }
      var type= 'goods'
      that.isDisable= true
      orderPayMoney(this.payInfo.id,type,data).then(res => {
        // console.log('res',res)
        // this.$toast(res.message)
        if(res.code == 200)
        {
          that.isDisable= true
          // this.$router.push({path:'/paySucceed'})
          // console.log(res.data.url)

          // 支付成功清除掉vuex
          this.$store.commit("setGoodsInfo",'');
          this.$store.commit("setSubmitNumber",'')
          this.$store.commit("setPayTypeId",'')// 一元购
          this.$store.commit("setPayInfo",''); // 支付信息


          if (res.data == ''){ // 余额支付
            this.$toast('支付成功')
            // this.isDisable=false
            setTimeout(() => {
              this.$router.push({path:'/user'})
            }, 1500)
          } else {
            var url = res.data.url
            window.location.href=url // 安卓ok
            window.open(url) // ios no
            // this.isDisable=false
           }

          this.isDisable=false
        }
        else
        {
          this.$toast(res.message)
          this.isDisable=false
          // this.$router.push('/');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-box{
  padding: 24px;margin-top: 30px;
  .btn{
    font-size: 32px;
    border-radius: 60px;font-weight: bold;
    color: #282828;
  }
  .cancel-btn{
    width: 262px;background: #FFFFFF;
    border: 2px solid #BBBBBB;padding: 24px 0;
  }
  .affirm-btn{
    width: 100%;background: #FDD80D;padding: 26px 0;text-align: center;
  }
}
.van-hairline--bottom::after {
  border-bottom-width: 0;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.pay-price{
  background: #FDD80D;color: #282828;text-align: center;padding-bottom: 56px;
  .pay-hint{
    font-size: 24px;padding-bottom: 34px;
  }
  .price-num{
    font-weight: bold;font-size: 60px;
    span{
      font-size: 44px;
    }
  }
}
.hint-box{
  background: #ffffff;padding:0 24px;font-size: 24px;color: #000000;text-align: left;
  .explain-title{
    padding: 20px 0;
  }
  .goods-box{
    padding-bottom: 20px;
  }
  .goods-title{
    padding: 0 20px;line-height: 40px;
  }
  .num{
    text-align: right;padding-top: 20px;
  }
  .bill-box{
    padding: 30px 0;border-top: 1px solid #DCDCDC;
  }
}
.select-box{
  padding: 0 24px;margin-top: 17px;background: #ffffff;
  .pay-item{
    font-size: 24px;color: #000000;padding: 24px 0;border-bottom: 1px solid #DCDCDC;
    .pay-content{
      img{
        width: 56px;height: auto;display: inline-block;margin-right: 30px;
      }
      .pay-txt{
        text-align: left;font-size: 24px;
        span{
          font-size: 18px;color: #8E8E8E;display: block;text-align: left;
        }
      }
    }
  }
}
</style>
